import { useState, useEffect } from "react";

import SelectForm from "./SelectForm";

export default function SearchBox({
  muscles,
  setSelectedIntensity,
  setSelectedMuscle,
  selectedIntensity,
  selectedMuscle,
}) {
  return (
    <section className="relative mt-32 py-14 z-10 w-[90%] bg-dark-blue mx-auto rounded-xl text-white">
      <div className="text-center px-4">
        <h3 className="font-black text-xl lg:text-3xl mb-4">
          Exercises you need to know
        </h3>
        <h5>Explore all free exercises and get shaped</h5>

        <div className="relative w-1/2 mx-auto mt-7">
          <SelectForm
            muscles={muscles}
            setSelectedIntensity={setSelectedIntensity}
            setSelectedMuscle={setSelectedMuscle}
            selectedIntensity={selectedIntensity}
            selectedMuscle={selectedMuscle}
          />
        </div>
      </div>
    </section>
  );
}
